import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModelService } from '../services/model.service';
import { NewProjectData } from '../entities/new-project.entity';

@Component({
	selector: 'app-new-project',
	templateUrl: './new-project.component.html',
	styleUrls: ['./new-project.component.scss']
})
export class NewProjectComponent implements OnDestroy {

	public isShown: boolean = false;
	private showSubs: Subscription;
	private nombre: string = '';

	public tipoProyecto = 0; // 0: todos, 1: gmap, 2: canvas.

	public npd: NewProjectData = new NewProjectData();

	constructor(
		public modelService: ModelService
		) {
		this.showSubs = modelService.newProjectSignal.subscribe((data: NewProjectData) => { this.show(); });
	}

	public show(role: number = 0, data?: NewProjectData): void {
		// En caso de que se reciba un data:
		// Se sobreescriben los datos que hayan llegado por Input() al componente
		this.tipoProyecto = role;

		if (!data) {
			this.npd = new NewProjectData();
			this.npd.title = ''; //this.modelService.getString('win_new_project_title');
			this.npd.message = ''; //this.modelService.getString('win_new_project_message');
		}
		else {
			this.npd.title = data.title;
			this.npd.message = data.message;
		}

		this.npd.nombre = '';
		this.npd.estado = 0;
		// this.message = data.message;//this.type = data.type;//this.nombre = data.nombre;  //this.estado = data.estado;
		this.isShown = true;
	}

	public close(): void {
		this.isShown = false;
	}

	public ngOnDestroy() {
		this.showSubs.unsubscribe();
	}

	public cancelar() {
		this.modelService.newProjectResultSignal.emit(this.npd);
		this.isShown = false;
	}

	public nuevoSatelite() {
		if (this.npd.nombre !== '') {
			this.npd.estado = 1;
			this.modelService.newProjectResultSignal.emit(this.npd);
			this.isShown = false;
		}
	}

	public nuevoMapa() {
		if (this.npd.nombre !== '') {
			this.npd.estado = 2;
			this.modelService.newProjectResultSignal.emit(this.npd);
			this.isShown = false;
		}
	}

	public disabled() {
		if (this.npd && this.npd.nombre) {
			this.npd.nombre = this.trimLeft(this.npd.nombre);
			// let tp : String = this.npd.nombre;
			// this.npd.nombre = tp.trimLeft().toString();
			// this.npd.nombre = this.npd.nombre.trimLeft();
			return !(this.npd.nombre !== '');
		}
		return true;
	}

	public trimLeft(valor: string): string {
		if (!valor) { return ''; }
		do {
			if (valor === ' ') { return ''; }
			if (valor[0] === ' ') {
				valor = valor.replace(' ', '');
			} else { return valor; }
		} while (true);
	}

}
